// ボス撃破画面：Space で最初から
import Phaser from 'phaser';

export class VictoryScene extends Phaser.Scene {
  constructor() {
    super('VictoryScene');
  }

  create(): void {
    const cx = this.scale.width / 2;
    const cy = this.scale.height / 2;
    this.add.rectangle(cx, cy, this.scale.width, this.scale.height, 0x001a33, 0.85);
    this.add
      .text(cx, cy - 40, 'BOSS DEFEATED', {
        fontFamily: 'monospace',
        fontSize: '36px',
        color: '#66ddff',
      })
      .setOrigin(0.5);
    this.add
      .text(cx, cy + 24, 'Press SPACE to play again', {
        fontFamily: 'monospace',
        fontSize: '16px',
        color: '#aaaaaa',
      })
      .setOrigin(0.5);
    this.input.keyboard!.once('keydown-SPACE', () => {
      this.scene.stop('UIScene');
      this.scene.stop('WorldScene');
      this.scene.start('WorldScene');
      this.scene.launch('UIScene');
      this.scene.stop();
    });
  }
}
